import React from 'react'
import { t } from 'ttag'

import { trackOutboundLink } from '../../actions'
import { useTitleChange } from '../../util/hooks'

const FinancialAid = () => {
  useTitleChange(t`Financial Aid`)

  return (
    <div className="container" id="colleges-financialaid">
      <img
        src="/images/common/lost1.jpg"
        align="right"
        width="400"
        height="300"
        id="finaid"
        className="pull-right"
      />
      <p className="instructions">
        {t`No matter where you go to school, paying for college is likely to be a
                substantial investment. While most people will end up having to pay at least part of the cost themselves,
                financial aid and scholarships can help offset your total expenses.`}{' '}
      </p>
      <p className="instructions">
        {t`Financial aid can be broken up into several categories. Need based awards are
                granted to people who demonstrate that paying for the cost of school would impose a financial hardship.
                Academic based awards are given to students who have demonstrated strong performance in school through
                good grades, or strong academic extra-curricular activities. Athletic based scholarships award tuition
                assistance to students who excel at various sporting activities and are recruited to play on the
                school's athletic team.`}
      </p>
      <h3>{t`Federal Sources`}</h3>
      <ul>
        <li>
          <a
            href="https://studentaid.gov/"
            onClick={e => {
              e.preventDefault()
              trackOutboundLink(e.target.href)
            }}>
            {t`Free Application for Federal Student Aid (FAFSA)`}
          </a>
        </li>
        <li>
          <a
            href="https://studentloans.gov/myDirectLoan/index.action"
            onClick={e => {
              e.preventDefault()
              trackOutboundLink(e.target.href)
            }}>
            {t`Student Loan Information`}
          </a>
        </li>
      </ul>
      <h3>{t`Private Sources`}</h3>
      <ul>
        <li>
          <a
            href="http://www.fastweb.com/"
            onClick={e => {
              e.preventDefault()
              trackOutboundLink(e.target.href)
            }}>
            FastWeb
          </a>
        </li>
        <li>
          <a
            href="http://www.finaid.org/"
            onClick={e => {
              e.preventDefault()
              trackOutboundLink(e.target.href)
            }}>
            FinAid
          </a>
        </li>
        <li>
          <a
            href="http://www.finaid.org/otheraid/sports.phtml"
            onClick={e => {
              e.preventDefault()
              trackOutboundLink(e.target.href)
            }}>
            {t`Sports Scholarships at FinAid`}
          </a>
        </li>
      </ul>
      <h3>{t`Special Scenarios`}</h3>
      <ul>
        <li>
          <a
            href="http://www.gibill.va.gov/"
            onClick={e => {
              e.preventDefault()
              trackOutboundLink(e.target.href)
            }}>
            {t`GI Bill - for those who have served in the military`}
          </a>
        </li>
        <li>
          <a
            href="http://aid.military.com/scholarship/search-for-scholarships.do"
            onClick={e => {
              e.preventDefault()
              trackOutboundLink(e.target.href)
            }}>
            {t`Military.com - military scholarship finder`}
          </a>
        </li>
      </ul>
    </div>
  )
}

export default FinancialAid
